module.exports = __webpack_public_path__ + "img/loading-icon.d6a749f9.svg";